export default {
  title: 'Începe abonamentul',
  title_confirm: 'Confirmă planul',
  step: 'Pasul {{current}} din {{total}}',
  subtitle: '{{name}} · 1 locație',
  trial_badge: '{{days}} zile gratuite',
  trial_headline: 'Primele {{days}} zile gratuite',
  then_price: 'Apoi {{price}} / lună per locație · TVA inclus',
  price_per_month: '{{price}} / lună',
  price_terms: 'Per locație, facturat lunar · TVA inclus',
  tier_upsell:
    'Treceți la {{threshold}}+ locații active, iar tariful pentru toate locațiile scade la {{price}} / lună per locație — automat.',
  tier_active: 'Tarif de volum — {{threshold}}+ locații active',
  due_today: 'Scadent astăzi',
  from_date: 'De la {{date}}',
  no_charge_today: 'Nu vei fi taxat astăzi.',
  no_charge_until: 'Nu veți fi taxat astăzi. Anulați până la {{date}} și nu plătiți nimic.',
  active: '{{plan}} este activ pentru acest restaurant.',
  active_with_trial: '{{plan}} este activ pentru acest restaurant, gratuit până la {{date}}.',
  terms:
    'Sunt de acord cu <a href="{{terms_url}}" target="_blank" rel="noreferrer">Termenii platformei de partener FoodAmigos</a>, inclusiv activarea, anularea și rambursările.',
  error: 'Nu am putut finaliza achiziția. Te rugăm să încerci din nou.',
  loading: 'Se verifică planul acestui restaurant…',
  load_error: 'Nu am putut verifica planul acestui restaurant.',
  unavailable: 'Acest produs nu este disponibil pentru acest restaurant. Contactați managerul de cont FoodAmigos.',
  products: {
    online_ordering: {
      features: {
        ordering: {
          title: 'Comenzi online',
          description: 'Comenzi directe pe site-ul propriu al restaurantului',
        },
        reservations: {
          title: 'Rezervări de masă',
          description: 'Oaspeții rezervă o masă direct online',
        },
        marketing: {
          title: 'Suita de marketing',
          description: 'Generator de oferte, program de fidelitate și răspunsuri AI la recenziile Google',
        },
        pricing: {
          title: '0% comision, fără taxă de activare',
          description: 'O licență per locație, facturată lunar',
        },
      },
    },
    mobile_app: {
      features: {
        app: {
          title: 'Aplicația proprie a restaurantului',
          description: 'Pe App Store și Google Play',
        },
        engagement: {
          title: 'Notificări push și fidelitate',
          description: 'Aduce oaspeții înapoi cu oferte și puncte',
        },
        ordering: {
          title: 'Comenzi cu 0% comision',
          description: 'Comenzi directe chiar din aplicație',
        },
        apple: {
          title: 'Cont Apple Developer necesar',
          description: '99 $/an, plătit către Apple, pe entitatea legală a restaurantului',
        },
      },
    },
    ai_website: {
      title: 'Abonament Website Builder',
      subtitle_domain: 'Publică site-ul lui {{name}} pe {{domain}}',
      features: {
        domain: {
          title: 'Site-ul tău, live pe propriul domeniu',
          description: 'Site-ul propriu al restaurantului',
        },
        ai: {
          title: 'Construit și actualizat cu AI',
          description: 'Creează pagini, texte și imagini pentru restaurant în câteva minute',
        },
        ordering: {
          title: 'Comenzi și rezervări integrate',
          description: 'Oaspeții comandă și rezervă o masă direct de pe site',
        },
        pricing: {
          title: 'Fără taxă de activare',
          description: 'O licență per locație, facturată lunar',
        },
      },
    },
    storefront: {
      title: 'Abonament Website Builder',
      subtitle_domain: 'Publică site-ul lui {{name}} pe {{domain}}',
      features: {
        domain: {
          title: 'Site-ul tău, live pe propriul domeniu',
          description: 'Site-ul propriu al restaurantului',
        },
        ai: {
          title: 'Construit și actualizat cu AI',
          description: 'Creează pagini, texte și imagini pentru restaurant în câteva minute',
        },
        ordering: {
          title: 'Comenzi și rezervări integrate',
          description: 'Oaspeții comandă și rezervă o masă direct de pe site',
        },
        pricing: {
          title: 'Fără taxă de activare',
          description: 'O licență per locație, facturată lunar',
        },
      },
    },
  },
  payment_method: {
    label: 'Metoda ta de plată de partener',
    on_file: 'Card salvat',
    pending_title: 'Se confirmă metoda de plată',
    pending: 'Stripe încă confirmă cardul adăugat. Poate dura un minut.',
    still_pending: 'Nu încă. Mai așteaptă puțin și verifică din nou.',
    error: 'Nu am putut deschide formularul de plată. Te rugăm să încerci din nou.',
  },
  buttons: {
    close: 'Închide',
    continue_to_payment: 'Continuă spre plată',
    start_trial: 'Începe perioada de probă de {{days}} zile',
    subscribe: 'Începe abonamentul',
    continue: 'Continuă',
    change: 'Schimbă',
    retry: 'Încearcă din nou',
    check_again: 'Verifică din nou',
    add_again: 'Adaugă din nou un card',
  },
};
